import React from 'react';
import logo from './logo.svg';
import Header from './components/Header';
import Home from './components/Home';

function App() {
  return (
    <div className="app-container">
      <Header />
      <main className="main-content">
        <Home />
      </main>
    </div>
  );
}

export default App;
